/* eslint-disable react/prop-types */
import cx from 'classnames';
import uniqId from 'uniqid';
import { CloudinaryPicture } from '@bwoty-web/ui-kit';
import { useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';

import GalleryButton from '../../../common/gallery/GalleryButton';

import './inspirationalImages.scss';

const InspirationalImage = ({
  children,
  className,
  image,
  isConceptHotel,
  isGlobe,
  isLarge,
  isSingle,
}) => {
  const imageIsString = typeof image === 'string';
  const fullWidth = isLarge && (isSingle || isConceptHotel || isGlobe);

  let sizes;
  switch (true) {
    case fullWidth:
      sizes = [
        {
          width: 1280,
          height: 510,
          breakpoint: 975,
        },
        {
          width: 925,
          height: 370,
          breakpoint: 768,
        },
        { width: 768, height: 300, breakpoint: 416 },
        { width: 415, height: isGlobe ? 240 : 350 },
      ];
      break;
    case isLarge:
      sizes = [
        {
          width: 800,
          height: 510,
          breakpoint: 975,
        },
        {
          width: 625,
          height: 370,
          breakpoint: 768,
        },
        { width: 768, height: 300, breakpoint: 416 },
        { width: 415, height: 350 },
      ];
      break;
    case isGlobe:
      sizes = [
        {
          width: 610,
          height: 420,
          breakpoint: 975,
        },
        { width: 450, height: 300, breakpoint: 768 },
        {
          width: 360,
          height: 225,
          breakpoint: 456,
        },
        {
          width: 190,
          height: 190,
        },
      ];
      break;
    default:
      sizes = [
        {
          width: 384,
          height: isConceptHotel ? 290 : 240,
          breakpoint: 975,
        },
        { width: 305, height: 175, breakpoint: 768 },
        {
          width: 365,
          height: 222,
          breakpoint: 416,
        },
        {
          width: 200,
          height: 120,
        },
      ];
  }

  if (image.googleMapUrl)
    return (
      <div className={className}>
        <img
          src={image.googleMapUrl}
          alt={image.alt || ''}
          className="gw-hotel-inspirational-images__map"
        />
        {children}
      </div>
    );
  return (
    <div className={className}>
      <CloudinaryPicture
        alt={image.altText || image.caption || image.alt || ''}
        img={imageIsString ? { cloudinaryUriTemplate: image } : image}
        retina
        sizes={sizes}
      />
      {children}
    </div>
  );
};

const InspirationalImages = ({
  images,
  imagesCount,
  labels,
  id,
  itemType = 'hotel',
  category,
  isConceptHotel,
  mapOnClick,
  section,
  hasMovies,
}) => {
  const isGlobe = useIsGlobetrotter();

  if (!images?.length) return null;

  // Opens the standalone GalleryView, which listens for this message.
  const openGallery = () => {
    window.postMessage(
      `gallery?itemType=${itemType}&id=${id}${
        category ? `&category=${category}` : ''
      }`,
    );
  };
  const imageCount = isConceptHotel && !isGlobe ? 3 : 2;
  const imageList = images.slice(0, 1 + imageCount);

  const singleImageLayout = imageList.length === 1;
  const doubleImageLayout = imageList.length === 2;

  return (
    <div
      className={cx('gw-hotel-inspirational-images', {
        'gw-hotel-inspirational-images--globe': isGlobe,
        'gw-hotel-inspirational-images--single': singleImageLayout,
        'gw-hotel-inspirational-images--double': doubleImageLayout,
      })}
    >
      {imageList.map((image, index) => {
        let onClick;
        let label;
        if (image.googleMapUrl) {
          onClick = () => {
            mapOnClick();
          };
          label = labels?.openMap;
        } else if (index === 0) {
          onClick = () => {
            openGallery();
          };
          label = `${
            hasMovies
              ? labels?.galleryOverviewButtontWithMovies
              : labels?.openImageGalleryButton
          }${!section ? ` (${imagesCount})` : ''}`;
        }

        const smallImgIdClassname =
          index !== 0 && `gw-hotel-inspirational-images__small--${index}`;

        return (
          <InspirationalImage
            key={uniqId('inspirational-image')}
            image={image}
            className={cx(
              {
                'gw-hotel-inspirational-images__large': index === 0,
                'gw-hotel-inspirational-images__small': index !== 0,
              },
              smallImgIdClassname,
            )}
            isConceptHotel={isConceptHotel}
            isGlobe={isGlobe}
            isLarge={index === 0 || doubleImageLayout}
            isSingle={singleImageLayout}
          >
            {onClick && label && (
              <GalleryButton
                className="gw-hotel-inspirational-images__gallery-button"
                onClick={onClick}
                text={label}
              />
            )}
          </InspirationalImage>
        );
      })}
    </div>
  );
};

export default InspirationalImages;
